import React from 'react';
import {connect} from 'react-redux';
import {TableContainer, Table, Tr, Td, TBody, THead, Th} from '@cjdev/visual-stack/lib/components/Table';
import { Button } from '@cjdev/visual-stack/lib/components/Button';
import {Panel, Header, Body} from '@cjdev/visual-stack/lib/components/Panel';
import {If} from '../If';
import { approvalsOf } from '../../approvals';

const Approval = ({approval}) => {

    return (
        <Tr>
            <Td>{approval.requestor.name}</Td>
            <Td>{approval.role} / {approval.account.name}</Td>
            <Td>{approval.reason}</Td>
            <Td><Button type="primary">Approve</Button></Td>
        </Tr>
    );

};

const Approvals = ({approvals}) => {
    approvals = approvals || [];
    return (
        <If condition = {approvals.length > 0}>
            <Panel>
                <Header>
                    Pending Approvals
                </Header>
                <Body>
                    <TableContainer>
                        <Table>
                            <THead>
                                <Tr>
                                    <Th>Requestor</Th>
                                    <Th>Requested Role / Account</Th>
                                    <Th>Reason</Th>
                                    <Th/>
                                </Tr>
                            </THead>
                            <TBody>
                                {approvals.map(a => <Approval key={JSON.stringify(a)} approval = {a} />)}
                            </TBody>
                        </Table>
                    </TableContainer>
                </Body>
            </Panel>
        </If>
    );
};

const ConnectedApprovals = connect(
    state => ({
        approvals: approvalsOf(state)
    })
)(Approvals);


export {Approvals, ConnectedApprovals};



// WEBPACK FOOTER //
// ./src/view/AccessPage/Approvals.js